import { Center, Spinner } from 'src/components/atoms';
import { BarStacked } from 'src/components/molecules';
import { GetCasesPerWeekBarStackedQuery } from 'src/graphql';
import { LoadingContainer } from './BarStackedContent.styles';

interface Props {
  isLoading: boolean;
  data: GetCasesPerWeekBarStackedQuery | undefined;
}

export const BarStackedContent = ({ isLoading, data }: Props) => {
  if (isLoading) {
    return (
      <Center as={LoadingContainer}>
        <Spinner data-testid="spinner" variant="secondary" size="xlarge" />
      </Center>
    );
  }

  const barStacked = data?.getCasesPerWeekBarStacked;

  return (
    <BarStacked
      xTitle={barStacked?.xTitle ?? ''}
      yTitle={barStacked?.yTitle ?? ''}
      show7And90Days={true}
      stackLabels={barStacked?.stackLabels ?? []}
      data={barStacked?.data ?? []}
    />
  );
};
